import dayjs from "utils/dayjs"
import i18n from "intl/i18n"

export async function updateLocale(language: string) {
    const normalizedLanguage = (language || "en").toLowerCase().replace("_", "-")
    const locale = normalizedLanguage.split("-")[0]

    if (locale !== "en") {
        const locales = import.meta.glob('/node_modules/dayjs/locale/{de,ru}.js');
        const localeImporter = locales[`/node_modules/dayjs/locale/${locale}.js`];
        if (localeImporter) {
            try {
                await localeImporter();
            } catch (e) { }
        } else {
            console.error(`Locale for ${locale} not found`);
            return;
        }
    }

    // Only override monthsShort when the translation yields a full 12-entry set.
    // dayjs' format("MMM") calls the array as a function if an indexed entry is
    // falsy (a short/missing array would crash), so fall back to the locale's
    // built-in monthsShort when the translation is absent (e.g. in tests).
    const monthsShort = (i18n.t('config.monthsShort')).split("_")
    dayjs.updateLocale(locale, {
        weekStart: 1, // first day of week - monday
        ...(monthsShort.length === 12 ? { monthsShort } : {}),
    })

    // Set the active global locale so subsequent dayjs(...).format(...) calls
    // use the translated month names / week config.
    dayjs.locale(locale)
}
